import React from 'react';
import { Clock, MapPin, DollarSign, Zap, Phone } from 'lucide-react';
import { features, companyInfo } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Clock: Clock,
  MapPin: MapPin,
  DollarSign: DollarSign,
  Zap: Zap
};

const WhyUsSection = () => {
  return (
    <section id="why-us" className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4">
            Why Choose <span className="text-[#ECEC75]">Lockout Bros?</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            We're committed to getting you back in quickly and safely.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="text-center p-6 rounded-xl bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-[#ECEC75] rounded-full flex items-center justify-center mx-auto mb-4">
                  <IconComponent className="w-7 h-7 text-gray-900" />
                </div>
                <h3 className="text-xl font-bold mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-400">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-2xl font-semibold mb-6">Don't wait - help is just a call away!</p>
          <a href={companyInfo.phoneLink}>
            <Button className="bg-[#ECEC75] hover:bg-yellow-300 text-gray-900 px-10 py-6 text-xl font-bold flex items-center gap-3 mx-auto transition-all hover:scale-105">
              <Phone className="w-6 h-6" />
              CALL {companyInfo.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
